import React from "react";

import shallow from "zustand/shallow";

import useStore from "../store";
import CategoryTreeItem from "./CategoryTreeItem";

const CategoryTree = () => {
    const [categories, handleNavigation, category, parent] = useStore(
        (state) => [
            state.categories,
            state.handleNavigation,
            state.category,
            state.parent,
        ],
        shallow
    );

    return (
        <div>
            {categories &&
                categories.map((item) => (
                    <CategoryTreeItem
                        key={item.id}
                        category={item}
                        selectedCategory={category}
                        handleNavigation={handleNavigation}
                        parent={parent}
                    />
                ))}
        </div>
    );
};

export default CategoryTree;
